import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

interface CancelLessonPayload {
  lessonId: string;
  // Read by the payout eligibility reducer to update the amount still due to the teacher
  hours: number;
  paidToTeacher: number;
}

export const teacherCancelLesson = createApiThunk<void, CancelLessonPayload>(
  "lessons/teacherCancelLesson",
  async ({ lessonId }, { extra: { teacherRepository } }) => {
    await teacherRepository!.cancelLesson(lessonId);
  },
);

export const resetLessonCancellation = createAction("lessons/resetLessonCancellation");
